import React from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import style from "./dashboard.module.scss";
import TileItems from "./TileItems";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useSelector } from "react-redux";
import MyChart from "./MyChart";
import BUVitems from "./BUVitems";
import CommissionFlow from "./CommissionFlow";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import "./SocialMedialTile.css";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
// import ProgressBar from "react-bootstrap/ProgressBar";
import "./tile.css";
import Example from "./MaterialTable";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

function Tile(props) {
  let { SponserData, commissionFlow } = props;
  console.log({ SponserData, commissionFlow });
  const replicaLink = props?.profile?.replica[0].link;
  const facebook = props?.profile?.replica[1].link;
  const twitter = props?.profile?.replica[2].link;
  // const linkedin = props?.profile?.replica[3].link;
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.Theme);
  const fallbackCutoffDate = "cutOffDate";
  const fallbackClaimDate = "claimDate";
  console.log("inside tiles component chart result", props.chartResult);
  //calculating total cycle psd and gsr
  let totalPsd = 0;
  let totalCycle = 0;
  let totalGsr = 0;

  if (props.rank) {
    props.rank.forEach((item) => {
      const psdValue = parseFloat(item.psd); // Convert to number
      if (!isNaN(psdValue)) {
        totalPsd += psdValue;
      }
    });
  }
  if (props.rank) {
    props.rank.forEach((item) => {
      const gsrValue = parseFloat(item.gsr); // Convert to number
      if (!isNaN(gsrValue)) {
        totalCycle += gsrValue;
      }
    });
  }
  if (props.rank) {
    props.rank.forEach((item) => {
      const cycleValue = parseFloat(item.cycle); // Convert to number
      if (!isNaN(cycleValue)) {
        totalGsr += cycleValue;
      }
    });
  }
  //progress bar- rank advice
  const replcalinkhandleClick = (url) => {
    // e.preventDefault();
    window.open(replicaLink);
  };
  const fbhandleClick = (url) => {
    // e.preventDefault();
    window.open(facebook);
  };
  const twitterhandleClick = (url) => {
    // e.preventDefault();
    window.open(twitter);
  };
  // const linkedinhandleClick = (url) => {
  //   // e.preventDefault();
  //   window.open(linkedin);
  // };

  return (
    <div className={style.dashboard_boxs_listing_sponcer_sec}>
      {/* //Reminder */}
      <Row className="fll_wdth_row_tab" style={{ marginTop: "20px" }}>
        <Col md={12} className={style.mid_flll_wdth}>
          {props.lodervalue && (
            <div className={style.sponcer_sec}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
              >
                <div className={style.sponcer_top_name_sec}>
                  <div className={style.sponcer_top_name_txt}>
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={170} count={1} />
                      <Skeleton width={110} count={1} />
                    </SkeletonTheme>
                  </div>

                  <div className={style.sponcer_top_ico}>
                    {" "}
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={60} height={80} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.spouncer_cnt_row}>
                    {[1, 2, 3, 4].map((data, index) => {
                      return (
                        <div className={style.spouncer_cnt_boxes} key={index}>
                          <SkeletonTheme
                            baseColor="#202020"
                            highlightColor="#444"
                          >
                            <Skeleton width={110} count={1} />
                            <Skeleton width={80} count={1} />
                          </SkeletonTheme>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {props && props.start_date && props.end_date && (
            <div className={`${style.sponcer_sec}`}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "30px",
                  background: "#e6cfaa",
                }}
              >
                <>
                  <div
                    style={{
                      color: "red",
                    }}
                  >
                    <strong style={{ fontWeight: "5x" }}> REMINDER</strong> :{" "}
                    <span style={{ color: "red" }}>
                      The next Encashment cutoff is on
                      <strong>
                        {" "}
                        {props?.start_date || fallbackCutoffDate}{" "}
                      </strong>
                      , at exactly 11:59 PM (GMT+8). Please make your encashment
                      request early to avoid congestion towards the cutoff date.
                      All NCR checks may be claimed at FERN Corporate Center on
                      <strong>
                        {" "}
                        {props?.end_date || fallbackClaimDate}{" "}
                      </strong>{" "}
                      (GMT+8)
                    </span>
                  </div>

                  <div className={style.spouncer_cnt_row}>
                    {/* Rest of the code */}
                  </div>
                </>
              </div>
            </div>
          )}
        </Col>
      </Row>
      {/* EWALLET iLIFEStyle and BUV */}
      <Row className="fll_wdth_row_tab" style={{ marginTop: "20px" }}>
        {/* ewallet lifestyle buv*/}
        <Col md={6} className="max-width-class" style={{ maxWidth: "100%" }}>
          <Col
            md={6}
            style={{ maxWidth: "100% " }}
            className={style.mid_flll_wdth}
          >
            {props.lodervalue && (
              <div className={style.boxes_lst_sec}>
                {[1, 2, 3, 4].map((items, index) => {
                  return (
                    <div className={style.list_boxes_main}>
                      <div
                        className={`${
                          currentTheme == "theme-dark"
                            ? `${style.dark_mode_dashboard_pannel_box} `
                            : `${style.dashboard_pannel_box}`
                        }`}
                      >
                        <div className={style.listing_box_sec}>
                          <div>
                            <SkeletonTheme
                              baseColor="#202020"
                              highlightColor="#444"
                            >
                              <Skeleton circle={true} height={90} width={90} />
                            </SkeletonTheme>
                          </div>
                          <div className={style.listing_box_head}>
                            <SkeletonTheme
                              baseColor="#202020"
                              highlightColor="#444"
                            >
                              <Skeleton width={100} count={1} />
                            </SkeletonTheme>
                          </div>
                          <div className={style.listing_box_cnout}>
                            <SkeletonTheme
                              baseColor="#202020"
                              highlightColor="#444"
                            >
                              <Skeleton width={50} count={1} />
                            </SkeletonTheme>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {props.Tiles && props.Tiles.length > 0 && (
              <div className={style.boxes_lst_sec}>
                {props.Tiles.map((items, index) => {
                  return (
                    <TileItems
                      amount={items.amount}
                      cumuAmount={items.cumulativeAmount}
                      text={items.text}
                      to={items.to}
                      key={index}
                      boxname={index}
                      filter={items.filter}
                      filterChange={props.filterChange}
                      lodervalue={props.lodervalue}
                      amount_withcurrency={items.withcurrency}
                    />
                  );
                })}
              </div>
            )}
          </Col>

          {/* BUV */}
          <Col
            md={6}
            style={{ maxWidth: "100% " }}
            className={style.mid_flll_wdth}
          >
            {props.lodervalue && (
              <div className={style.sponcer_sec}>
                <div
                  className={`${
                    currentTheme == "theme-dark"
                      ? `${style.dark_mode_dashboard_pannel_box}`
                      : `${style.dashboard_pannel_box}`
                  }`}
                >
                  <div className={style.sponcer_top_name_sec}>
                    <div className={style.sponcer_top_name_txt}>
                      <SkeletonTheme baseColor="#202020" highlightColor="#444">
                        <Skeleton width={170} count={1} />
                        <Skeleton width={110} count={1} />
                      </SkeletonTheme>
                    </div>

                    <div className={style.sponcer_top_ico}>
                      {" "}
                      <SkeletonTheme baseColor="#202020" highlightColor="#444">
                        <Skeleton width={60} height={80} count={1} />
                      </SkeletonTheme>
                    </div>
                    <div className={style.spouncer_cnt_row}>
                      {[1, 2, 3, 4].map((data, index) => {
                        return (
                          <div className={style.spouncer_cnt_boxes} key={index}>
                            <SkeletonTheme
                              baseColor="#202020"
                              highlightColor="#444"
                            >
                              <Skeleton width={110} count={1} />
                              <Skeleton width={80} count={1} />
                            </SkeletonTheme>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {props.SponserData && props.pvData[0].remainingBuv && (
              <div className={`${style.sponcer_sec}`}>
                <div
                  className={`${
                    currentTheme == "theme-dark"
                      ? `${style.dark_mode_dashboard_pannel_box}`
                      : `${style.dashboard_pannel_box}`
                  }`}
                  style={{ width: "100%", height: "100%", marginTop: "15px" }}
                >
                  <>
                    {props.pvData &&
                      props.pvData[0].remainingBuv &&
                      props.pvData.length > 0 && (
                        <div className={style.boxes_lst_sec_buv}>
                          {props.pvData.map((items, index) => {
                            if (items.remainingBuv) {
                              return (
                                <BUVitems
                                  remainingBUV={items.remainingBuv}
                                  accumulatedBuv={items.accumulatedBuv}
                                />
                              );
                            }
                          })}
                        </div>
                      )}

                    <div className={style.spouncer_cnt_row}>
                      {props.pvData.map((data, index) => {
                        return (
                          <div
                            className={`${
                              currentTheme == "theme-dark"
                                ? `${style.dark_mode_spouncer_cnt_boxes}`
                                : `${style.spouncer_cnt_boxes}`
                            }`}
                            key={index}
                          >
                            {/* {t("Common." + data.text)} */}
                            <strong>{data.head}</strong>
                          </div>
                        );
                      })}
                      <div></div>
                    </div>
                  </>
                </div>
              </div>
            )}
          </Col>
        </Col>
        {/* announcement */}
        <Col md={6} className="max-width-class" style={{ maxWidth: "100%" }}>
          <Col md={12} className={style.mid_flll_wdth}>
            {props.lodervalue && (
              <div className={style.sponcer_sec}>
                <div
                  className={`${
                    currentTheme == "theme-dark"
                      ? `${style.dark_mode_dashboard_pannel_box}`
                      : `${style.dashboard_pannel_box}`
                  }`}
                >
                  <div className={style.sponcer_top_name_sec}>
                    <div className={style.sponcer_top_name_txt}>
                      <SkeletonTheme baseColor="#202020" highlightColor="#444">
                        <Skeleton width={170} count={1} />
                        <Skeleton width={110} count={1} />
                      </SkeletonTheme>
                    </div>

                    <div className={style.sponcer_top_ico}>
                      {" "}
                      <SkeletonTheme baseColor="#202020" highlightColor="#444">
                        <Skeleton width={60} height={80} count={1} />
                      </SkeletonTheme>
                    </div>
                    <div className={style.spouncer_cnt_row}>
                      {[1, 2, 3, 4].map((data, index) => {
                        return (
                          <div className={style.spouncer_cnt_boxes} key={index}>
                            <SkeletonTheme
                              baseColor="#202020"
                              highlightColor="#444"
                            >
                              <Skeleton width={110} count={1} />
                              <Skeleton width={80} count={1} />
                            </SkeletonTheme>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.announcements && props.announcements.length > 0 && (
              <div className={`${style.sponcer_sec}`}>
                <div
                  className={`${
                    currentTheme == "theme-dark"
                      ? `${style.dark_mode_dashboard_pannel_box}`
                      : `${style.dashboard_pannel_box}`
                  }`}
                  // style={{ borderRight: "1px solid #ccc" }} // Add this line to create a vertical border
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "30px",
                    maxheight: "350px",
                  }}
                >
                  <>
                    <div style={{ marginBottom: "20px", fontWeight: "bold" }}>
                      Announcements
                    </div>

                    <div
                      style={{
                        overflow: "scroll",
                        maxHeight: "485px",
                        height: "100%",
                      }}
                    >
                      {props.announcements.map((items) => {
                        console.log("announcemnttt", items);
                        return items.open ? (
                          <a href={items.link} target="_blank">
                            <img
                              style={{ width: "100%", paddingBottom: "20px" }}
                              src={items.image}
                              alt=""
                            />
                          </a>
                        ) : (
                          <img
                            style={{ width: "100%", paddingBottom: "20px" }}
                            src={items.image}
                            alt=""
                          />
                        );
                      })}
                    </div>

                    <div className={style.spouncer_cnt_row}>
                      {props.pvData.map((data, index) => {
                        return (
                          <div
                            className={`${
                              currentTheme == "theme-dark"
                                ? `${style.dark_mode_spouncer_cnt_boxes}`
                                : `${style.spouncer_cnt_boxes}`
                            }`}
                            key={index}
                          >
                            <strong>{data.head}</strong>
                          </div>
                        );
                      })}
                      <div></div>
                    </div>
                  </>
                </div>
              </div>
            )}
          </Col>
        </Col>
      </Row>
      <Row className="fll_wdth_row_tab" style={{ marginTop: "20px" }}>
        {/* COMMISSION FLOW */}

        <Col
          md={12}
          className={style.mid_flll_wdth}
          style={{ marginTop: "20px" }}
        >
          {props.lodervalue && (
            <div className={style.sponcer_sec}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
              >
                <div className={style.sponcer_top_name_sec}>
                  <div className={style.sponcer_top_name_txt}>
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={170} count={1} />
                      <Skeleton width={110} count={1} />
                    </SkeletonTheme>
                  </div>

                  <div className={style.sponcer_top_ico}>
                    {" "}
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={60} height={80} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.spouncer_cnt_row}>
                    {[1, 2, 3, 4].map((data, index) => {
                      return (
                        <div className={style.spouncer_cnt_boxes} key={index}>
                          <SkeletonTheme
                            baseColor="#202020"
                            highlightColor="#444"
                          >
                            <Skeleton width={110} count={1} />
                            <Skeleton width={80} count={1} />
                          </SkeletonTheme>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {props.todayResponse.length > 0 && (
            <div className={`${style.sponcer_sec}`}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
                style={{ width: "100%", height: "100%" }}
              >
                <>
                  <CommissionFlow
                    commissionFlow={props.commissionFlow}
                    todayResponse={props.todayResponse}
                    accumulatedResponse={props.accumulatedResponse}
                    data={props.data}
                    accumulatedRange={props.data.accumulatedRangeResponse}
                  />

                  {props.sponsorData && (
                    <div className={style.spouncer_cnt_row}>
                      {props.pvData &&
                        props.pvData.map((data, index) => {
                          return (
                            <div
                              className={`${
                                currentTheme == "theme-dark"
                                  ? `${style.dark_mode_spouncer_cnt_boxes}`
                                  : `${style.spouncer_cnt_boxes}`
                              }`}
                              key={index}
                            >
                              <strong>{data.head}</strong>
                            </div>
                          );
                        })}
                      <div></div>
                    </div>
                  )}
                </>
              </div>
            </div>
          )}
        </Col>
      </Row>

      {/* Lifetime Chart   rank advice,,,, monthly maintenance  , Daily Cycle Count    */}
      <Row className="fll_wdth_row_tab" style={{ marginTop: "20px" }}>
        {/* chart */}
        <Col md={3} className={style.mid_flll_wdth}>
          {props.lodervalue && (
            <div className={style.sponcer_sec}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
              >
                <div className={style.sponcer_top_name_sec}>
                  <div className={style.sponcer_top_name_txt}>
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={170} count={1} />
                      <Skeleton width={110} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.sponcer_top_ico}>
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={60} height={80} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.spouncer_cnt_row}>
                    {[1, 2, 3, 4].map((data, index) => {
                      return (
                        <div className={style.spouncer_cnt_boxes} key={index}>
                          <SkeletonTheme
                            baseColor="#202020"
                            highlightColor="#444"
                          >
                            <Skeleton width={110} count={1} />
                            <Skeleton width={80} count={1} />
                          </SkeletonTheme>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {props.SponserData && props.chartResult && (
            <div className={`${style.sponcer_sec}`}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
              >
                {props && props.chartData && (
                  <div
                    style={{ textAlign: "center" }}
                    className={style.chartContainer}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                      Lifetime Income Chart
                    </span>
                    <br />
                    <br />
                    <div style={{ textAlign: "center" }}>
                      <MyChart
                        chartData={props.chartData}
                        data={props.chartResult}
                      />
                    </div>
                  </div>
                )}

                <div className={style.spouncer_cnt_row}>
                  {props.pvData.map((data, index) => {
                    return (
                      <div
                        className={`${
                          currentTheme == "theme-dark"
                            ? `${style.dark_mode_spouncer_cnt_boxes}`
                            : `${style.spouncer_cnt_boxes}`
                        }`}
                        key={index}
                      >
                        <strong>{data.head}</strong>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </Col>

        {/* rank advice  */}
        <Col md={5} className={style.mid_flll_wdth}>
          <div
            className={`${style.sponcer_sec}`}
            // style={{ marginBottom: "-50px" }}
          >
            <div
              className={`${
                currentTheme == "theme-dark"
                  ? `${style.dark_mode_dashboard_pannel_box}`
                  : `${style.dashboard_pannel_box}`
              }`}
            >
              <>
                <div style={{ height: "200px", overflow: "scroll" }}>
                  <Table style={{ padding: "5px !important" }}>
                    <TableHead style={{ padding: "5px !important" }}>
                      <TableRow>
                        <TableCell
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            width: "30%",
                            padding: "5px",
                          }}
                        >
                          Rank Advance
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            width: "20%",
                            padding: "5px",
                          }}
                        >
                          PSD
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            width: "20%",
                            padding: "5px",
                          }}
                        >
                          CYCLE
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            width: "20%",
                            padding: "5px",
                          }}
                        >
                          GSR
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{ backgroundColor: "white" }}>
                      {props.rank &&
                        props.rank.map((items) => (
                          <TableRow key={items.title}>
                            <TableCell style={{ padding: "5px" }}>
                              <div
                                style={
                                  {
                                    // display: "flex",
                                    // alignItems: "center",
                                    // width: "200px",
                                  }
                                }
                              >
                                <span
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: "normal",
                                    position: "relative",
                                    marginLeft: "5px",
                                    padding: "1px",
                                  }}
                                >
                                  {/* ⚪{" "} */}
                                  {items.title
                                    .toLowerCase()
                                    .replace(/^(.)|\s(.)/g, (letter) =>
                                      letter.toUpperCase()
                                    )}
                                </span>

                                <div
                                  style={{
                                    position: "relative",
                                    height: "10px",
                                    borderRadius: "10px",
                                    backgroundColor: "#ccc",
                                    overflow: "hidden",
                                    flex: "2 1 auto",
                                    marginRight: "5px",
                                    width: "60%",
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      height: "100%",
                                      width: `${items.percentage}%`,
                                      backgroundColor: "#1FC71F",
                                      borderRadius: "8px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      color: "black",
                                      fontSize: "small",
                                      zIndex: 1,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </TableCell>

                            <TableCell style={{ width: "20%", padding: "5px" }}>
                              {items.psd}
                            </TableCell>
                            <TableCell style={{ width: "20%", padding: "5px" }}>
                              {items.cycle}
                            </TableCell>
                            <TableCell style={{ width: "20%", padding: "5px" }}>
                              {items.gsr}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </div>

                <Grid container justifyContent="space-between" spacing={2}>
                  <Grid item xs={4}>
                    <Typography
                      variant="body1"
                      align="center"
                      style={{ fontSize: "35px" }}
                    >
                      <strong>{props?.totalCycle}</strong>
                    </Typography>
                    <Typography
                      variant="body1"
                      align="center"
                      style={{ fontSize: "30px", fontWeight: "lighter" }}
                    >
                      Total Cycle
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="body1"
                      align="center"
                      style={{ fontSize: "25px" }}
                    >
                      <strong>{props?.totalPSD}</strong>
                    </Typography>
                    <Typography
                      variant="body1"
                      align="center"
                      style={{ fontSize: "30px", fontWeight: "lighter" }}
                    >
                      Total PSD
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="body1"
                      align="center"
                      style={{ fontSize: "25px" }}
                    >
                      <strong>{props?.totalgsr}</strong>
                    </Typography>
                    <Typography
                      variant="body1"
                      align="center"
                      style={{ fontSize: "30px", fontWeight: "lighter" }}
                    >
                      Total GSR
                    </Typography>
                  </Grid>
                </Grid>
              </>
            </div>
          </div>
        </Col>
        {/*  monthly maintenance */}
        <Col md={2} className={style.mid_flll_wdth}>
          {props.lodervalue && (
            <div className={style.sponcer_sec}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? style.dark_mode_dashboard_pannel_box
                    : style.dashboard_pannel_box
                }`}
              >
                <div className={style.sponcer_top_name_sec}>
                  <div className={style.sponcer_top_name_txt}>
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={170} count={1} />
                      <Skeleton width={110} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.sponcer_top_ico}>
                    {" "}
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={60} height={80} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.spouncer_cnt_row}>
                    {[1, 2, 3, 4].map((data, index) => {
                      return (
                        <div className={style.spouncer_cnt_boxes} key={index}>
                          <SkeletonTheme
                            baseColor="#202020"
                            highlightColor="#444"
                          >
                            <Skeleton width={110} count={1} />
                            <Skeleton width={80} count={1} />
                          </SkeletonTheme>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {props.maintenance && (
            <div className={`${style.sponcer_sec}`}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? style.dark_mode_dashboard_pannel_box
                    : style.dashboard_pannel_box
                }`}
              >
                <div>
                  <div className={style.hint}>
                    <span style={{ fontSize: "14px", fontWeight: "bolder" }}>
                      Monthly Maintenance
                    </span>

                    <Tooltip
                      title={
                        <div>
                          <span>
                            Please note: Retro Maintenance will not be counted
                            for GSR Maintenance.PV of codes activated on the
                            same month of encoding cannot be combined with PV
                            for Retro Maintenance
                          </span>
                        </div>
                      }
                      placement="top"
                    >
                      <InfoIcon
                        style={{
                          fontSize: "20px",
                          padding: "2px",
                          lineHeight: 1,
                        }}
                      />
                    </Tooltip>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    {props.maintenance.map((items) => {
                      return (
                        <>
                          <div>
                            <div
                              style={{
                                color: "#000",
                                paddingTop: "20px",
                                fontSize: "small",
                              }}
                            >
                              <h2
                                style={{
                                  color: "#000",
                                  paddingTop: "30px",
                                  fontSize: "29px",
                                  fontWeight: "bolder",
                                }}
                              >
                                {items.value}
                              </h2>
                            </div>
                            <div style={{ fontSize: "smaller" }}>
                              {t(`Common.${items.title}`)}
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>

                  <div className={style.spouncer_cnt_row}>
                    {props.pvData.map((data, index) => {
                      return (
                        <div
                          className={`${
                            currentTheme == "theme-dark"
                              ? style.dark_mode_spouncer_cnt_boxes
                              : style.spouncer_cnt_boxes
                          }`}
                          key={index}
                        >
                          {/* {t("Common." + data.text)} */}
                          <strong style={{ fontSize: "smaller" }}>
                            {data.head}
                          </strong>
                        </div>
                      );
                    })}
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Col>

        {/* Daily cycle count */}
        <Col md={2} className={style.mid_flll_wdth}>
          {props.lodervalue && (
            <div className={style.sponcer_sec}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? style.dark_mode_dashboard_pannel_box
                    : style.dashboard_pannel_box
                }`}
              >
                <div className={style.sponcer_top_name_sec}>
                  <div className={style.sponcer_top_name_txt}>
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={170} count={1} />
                      <Skeleton width={110} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.sponcer_top_ico}>
                    {" "}
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={60} height={80} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.spouncer_cnt_row}>
                    {[1, 2, 3, 4].map((data, index) => {
                      return (
                        <div className={style.spouncer_cnt_boxes} key={index}>
                          <SkeletonTheme
                            baseColor="#202020"
                            highlightColor="#444"
                          >
                            <Skeleton width={110} count={1} />
                            <Skeleton width={80} count={1} />
                          </SkeletonTheme>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          {props.cycleCount && props.cycleCount.length > 0 && (
            <div className={style.sponcer_sec}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? style.dark_mode_dashboard_pannel_box
                    : style.dashboard_pannel_box
                }`}
              >
                <>
                  <strong style={{ fontSize: "14px", fontWeight: "bolder" }}>
                    Daily Cycle Count
                  </strong>
                  <div style={{ textAlign: "center" }}>
                    {props.cycleCount.map((items) => {
                      return (
                        <>
                          <div>
                            <br />

                            <div>
                              <h2
                                style={{
                                  color: "#000",
                                  paddingTop: "30px",
                                  fontSize: "29px",
                                  fontWeight: "bolder",
                                }}
                              >
                                {items.value}
                              </h2>
                            </div>
                            <div style={{ fontSize: "smaller" }}>
                              {t(`Common.${items.title}`)}
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>

                  <div className={style.spouncer_cnt_row}>
                    {props.pvData.map((data, index) => {
                      return (
                        <div
                          className={`${
                            currentTheme == "theme-dark"
                              ? style.dark_mode_spouncer_cnt_boxes
                              : style.spouncer_cnt_boxes
                          }`}
                          key={index}
                        >
                          <strong style={{ fontSize: "smaller" }}>
                            {data.head}
                          </strong>
                        </div>
                      );
                    })}
                    <div></div>
                  </div>
                </>
              </div>
            </div>
          )}
        </Col>
      </Row>

      {/* Latest Downline */}
      <Row className="fll_wdth_row_tab" style={{ marginTop: "20px" }}>
        <Col md={12} className={`${style.mid_flll_wdth} ${style.colFullWidth}`}>
          {props.lodervalue && (
            <div className={style.sponcer_sec}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
              >
                <div className={style.sponcer_top_name_sec}>
                  <div className={style.sponcer_top_name_txt}>
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={170} count={1} />
                      <Skeleton width={110} count={1} />
                    </SkeletonTheme>
                  </div>

                  <div className={style.sponcer_top_ico}>
                    {" "}
                    <SkeletonTheme baseColor="#202020" highlightColor="#444">
                      <Skeleton width={60} height={80} count={1} />
                    </SkeletonTheme>
                  </div>
                  <div className={style.spouncer_cnt_row}>
                    {[1, 2, 3, 4].map((data, index) => {
                      return (
                        <div className={style.spouncer_cnt_boxes} key={index}>
                          <SkeletonTheme
                            baseColor="#202020"
                            highlightColor="#444"
                          >
                            <Skeleton width={110} count={1} />
                            <Skeleton width={80} count={1} />
                          </SkeletonTheme>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}
          {props.new_members && (
            <div className={`${style.sponcer_sec}`}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_dashboard_pannel_box}`
                    : `${style.dashboard_pannel_box}`
                }`}
                style={{
                  borderRight: "1px solid #ccc",
                  overflowY: "scroll",
                  width: "100%",
                  maxWidth: "100%",
                  height: "350px",
                }}
              >
                <>
                  <h4 className="card-header" style={{ fontWeight: "bolder" }}>
                    {" "}
                    Latest Downlines
                  </h4>

                  <div style={{ overflowX: "auto" }}>
                    <Example data={props.new_members} />
                  </div>

                  <div className={style.spouncer_cnt_row}></div>
                </>
              </div>
            </div>
          )}
        </Col>
      </Row>

      {/* promotion tool */}

      <Row className="fll_wdth_row_tab">
        <Col
          md={3}
          className={style.mid_flll_wdth}
          style={{ marginTop: "20px", borderRadius: "35px" }}
        >
          {props && (
            <div className={`${style.sponcer_sec}`}>
              <>
                <div>
                  <div className="social-media-tile card">
                    <h4
                      className="card-header"
                      style={{ fontWeight: "bolder" }}
                    >
                      Promotion Tools
                    </h4>
                    <div className="card-body">
                      <div className="card-header-replica">
                        <h5 style={{ fontWeight: "bolder" }}>Replica Link:</h5>
                        <input type="text" value={replicaLink} readOnly />
                        <button
                          style={{ margin: "0px" }}
                          className="btn btn-primary"
                          onClick={() => {
                            const copyText =
                              document.querySelector('input[type="text"]');
                            copyText.select();
                            document.execCommand("copy");
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Copy</span>
                        </button>
                      </div>

                      <div className="card-footer">
                        <a className="facebook" onClick={fbhandleClick}>
                          <FontAwesomeIcon
                            style={{ fontSize: "2rem" }}
                            icon={faFacebook}
                            className="facebook"
                          />
                        </a>
                        <a className="twitter" onClick={twitterhandleClick}>
                          <FontAwesomeIcon
                            style={{ fontSize: "2rem" }}
                            icon={faTwitter}
                            className="twitter"
                          />
                        </a>
                        {/* <a className="linkedin" onClick={linkedinhandleClick}>
                          <FontAwesomeIcon
                            style={{ fontSize: "2rem" }}
                            icon={faLinkedin}
                            className="linkedin"
                          />
                        </a> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className={style.spouncer_cnt_row}>
                  <div></div>
                </div>
              </>
            </div>
          )}
        </Col>
        {props &&
          props.profile &&
          props.profile.fourpAccounts &&
          props.profile.fourpAccounts.length > 0 && (
            <Col
              md={7}
              className={style.mid_flll_wdth}
              style={{ marginTop: "20px", borderRadius: "35px" }}
            >
              <div className={`${style.sponcer_sec}`}>
                <div>
                  <div className="social-media-tile card">
                    <h4
                      className="card-header"
                      style={{ fontWeight: "bolder" }}
                    >
                      4P Accounts
                    </h4>
                    <div className="card-body">
                      <div style={{ height: "200px", overflow: "scroll" }}>
                        <Table style={{ padding: "5px !important" }}>
                          <TableHead style={{ padding: "5px !important" }}>
                            <TableRow>
                              <TableCell
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  width: "30%",
                                  padding: "5px",
                                }}
                              >
                                Number
                              </TableCell>
                              <TableCell
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  width: "20%",
                                  padding: "5px",
                                }}
                              >
                                4P Username
                              </TableCell>
                              <TableCell
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  width: "20%",
                                  padding: "5px",
                                }}
                              >
                                Position
                              </TableCell>
                              <TableCell
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  width: "20%",
                                  padding: "5px",
                                }}
                              >
                                PV Activated
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody style={{ backgroundColor: "white" }}>
                            {props?.profile?.fourpAccounts?.map((items) => (
                              <TableRow key={items.title}>
                                <TableCell
                                  style={{ width: "20%", padding: "5px" }}
                                >
                                  {items.id}
                                </TableCell>
                                <TableCell
                                  style={{ width: "20%", padding: "5px" }}
                                >
                                  {items.username}
                                </TableCell>
                                <TableCell
                                  style={{ width: "20%", padding: "5px" }}
                                >
                                  {items.position}
                                </TableCell>
                                <TableCell
                                  style={{ width: "20%", padding: "5px" }}
                                >
                                  {items.amount}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )}
      </Row>
    </div>
  );
}

export default Tile;
